import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instance1wzn9b23peown as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$default3mq4ssp61rg7w as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance23401jnwmesxf as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().d4i("Buffer doesn't contain required number of bytes (size: " + $this.q2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.x4h_1 = null;
        this.y4h_1 = null;
        this.z4h_1 = 0n;
      }
      q2() {
        return this.z4h_1;
      }
      i3y() {
        return this;
      }
      j3y() {
        return this.q2() === 0n;
      }
      k3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() < byteCount) {
          throw EOFException().d4i("Buffer doesn't contain required number of bytes (size: " + this.q2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      p3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        return this.q2() >= byteCount;
      }
      s3y() {
        var tmp0_elvis_lhs = this.x4h_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize === 0) {
          this.l4i();
          return this.s3y();
        }
        var v = segment.m4i();
        this.z4h_1 = subtract(this.z4h_1, 1n);
        if (segmentSize === 1) {
          this.l4i();
        }
        return v;
      }
      n4i() {
        var tmp0_elvis_lhs = this.x4h_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize < 2) {
          this.k3y(2n);
          if (segmentSize === 0) {
            this.l4i();
            return this.n4i();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.s3y() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.s3y() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.o4i();
        this.z4h_1 = subtract(this.z4h_1, 2n);
        if (segmentSize === 2) {
          this.l4i();
        }
        return v;
      }
      p4i() {
        return Unit_instance;
      }
      q4i(out, startIndex, endIndex) {
        checkBounds(this.q2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.z4h_1 = add(out.z4h_1, remainingByteCount);
        var s = this.x4h_1;
        while (currentOffset >= fromInt(ensureNotNull(s).g4i_1 - s.f4i_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.g4i_1 - s.f4i_1 | 0));
          s = s.j4i_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).r4i();
          copy.f4i_1 = copy.f4i_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.f4i_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.g4i_1;
          tmp.g4i_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.x4h_1 == null) {
            out.x4h_1 = copy;
            out.y4h_1 = copy;
          } else if (false) {
            out.y4h_1 = ensureNotNull(out.y4h_1).s4i(copy).t4i();
            if (ensureNotNull(out.y4h_1).k4i_1 == null) {
              out.x4h_1 = out.y4h_1;
            }
          } else {
            out.y4h_1 = ensureNotNull(out.y4h_1).s4i(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.g4i_1 - copy.f4i_1 | 0));
          currentOffset = 0n;
          s = s.j4i_1;
        }
      }
      u4i() {
        var result = this.q2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.y4h_1);
        if (tail.g4i_1 < 8192 && tail.i4i_1) {
          result = subtract(result, fromInt(tail.g4i_1 - tail.f4i_1 | 0));
        }
        return result;
      }
      m3w(position) {
        if (position < 0n || position >= this.q2()) {
          throw IndexOutOfBoundsException().i3('position (' + position.toString() + ') is not within the range [0..size(' + this.q2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.x4h_1).v4i(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.x4h_1 == null) {
            return ensureNotNull(null).v4i(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.q2(), position) < position) {
            var s = this.y4h_1;
            var offset = this.q2();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.g4i_1 - s.f4i_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.k4i_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).v4i(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.x4h_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.g4i_1 - s_0.f4i_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.j4i_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).v4i(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      y4() {
        return this.z3u(this.q2());
      }
      z3u(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.x4h_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().d4i('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.g4i_1 - head.f4i_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.z4h_1 = subtract(this.z4h_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.f4i_1 = head.f4i_1 + toSkip | 0;
          if (head.f4i_1 === head.g4i_1) {
            this.l4i();
          }
        }
      }
      w4i(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.x4h_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.q2();
        var toCopy = Math.min(tmp0, b);
        s.x4i(sink, startIndex, startIndex + toCopy | 0);
        this.z4h_1 = subtract(this.z4h_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.l4i();
        }
        return toCopy;
      }
      y4i(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.q2() ? this.q2() : byteCount;
        sink.z4i(this, bytesWritten);
        return bytesWritten;
      }
      a4j(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.q2() < byteCount) {
          sink.z4i(this, this.q2());
          throw EOFException().d4i('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.q2().toString() + ' bytes were written.');
        }
        sink.z4i(this, byteCount);
      }
      b4j(sink) {
        var byteCount = this.q2();
        if (byteCount > 0n) {
          sink.z4i(this, byteCount);
        }
        return byteCount;
      }
      k40() {
        return buffered(new (PeekSource())(this));
      }
      c4j(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().o2(toString(message));
        }
        if (this.y4h_1 == null) {
          var result = SegmentPool_instance.c3w();
          this.x4h_1 = result;
          this.y4h_1 = result;
          return result;
        }
        var t = ensureNotNull(this.y4h_1);
        if ((t.g4i_1 + minimumCapacity | 0) > 8192 || !t.i4i_1) {
          var newTail = t.s4i(SegmentPool_instance.c3w());
          this.y4h_1 = newTail;
          return newTail;
        }
        return t;
      }
      f4j(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.c4j(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.g4j();
          var toCopy = Math.min(tmp0, b);
          tail.h4j(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.z4h_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.z4h_1 = add(tmp0_0, fromInt(other));
      }
      j4j(source, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var read = source.y4i(this, remainingByteCount);
          if (read === -1n) {
            throw EOFException().d4i('Source exhausted before reading ' + byteCount.toString() + ' bytes. ' + ('Only ' + subtract(byteCount, remainingByteCount).toString() + ' were read.'));
          }
          remainingByteCount = subtract(remainingByteCount, read);
        }
      }
      z4i(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().o2(toString(message));
        }
        checkOffsetAndCount(source.z4h_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.x4h_1).q2())) {
            var tail = this.y4h_1;
            var tmp;
            if (!(tail == null) && tail.i4i_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.g4i_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.k4j() ? 0 : tail.f4i_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.x4h_1).m4j(tail, convertToInt(remainingByteCount));
              source.z4h_1 = subtract(source.z4h_1, remainingByteCount);
              this.z4h_1 = add(this.z4h_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.x4h_1 = ensureNotNull(source.x4h_1).l4j(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.x4h_1);
          var movedByteCount = fromInt(segmentToMove.q2());
          source.x4h_1 = segmentToMove.n4j();
          if (source.x4h_1 == null) {
            source.y4h_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.x4h_1 == null) {
            this.x4h_1 = segmentToMove;
            this.y4h_1 = segmentToMove;
          } else if (true) {
            this.y4h_1 = ensureNotNull(this.y4h_1).s4i(segmentToMove).t4i();
            if (ensureNotNull(this.y4h_1).k4i_1 == null) {
              this.x4h_1 = this.y4h_1;
            }
          } else {
            this.y4h_1 = ensureNotNull(this.y4h_1).s4i(segmentToMove);
          }
          source.z4h_1 = subtract(source.z4h_1, movedByteCount);
          this.z4h_1 = add(this.z4h_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      o4j(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.y4i(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      p4j(byte) {
        this.c4j(1).q4j(byte);
        this.z4h_1 = add(this.z4h_1, 1n);
      }
      r4j(short) {
        this.c4j(2).s4j(short);
        this.z4h_1 = add(this.z4h_1, 2n);
      }
      m6() {
        return Unit_instance;
      }
      toString() {
        if (this.q2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().vb(imul(len, 2) + (this.q2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.x4h_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.q2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.t4j(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.o1(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.o1(tmp_1[tmp$ret$5]);
          }
          curr = curr.j4i_1;
        }
        if (this.q2() > fromInt(maxPrintableBytes)) {
          builder.o1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.q2().toString() + ' hex=' + builder.toString() + ')';
      }
      l4i() {
        var oldHead = ensureNotNull(this.x4h_1);
        var nextHead = oldHead.j4i_1;
        this.x4h_1 = nextHead;
        if (nextHead == null) {
          this.y4h_1 = null;
        } else {
          nextHead.k4i_1 = null;
        }
        oldHead.j4i_1 = null;
        SegmentPool_instance.u4j(oldHead);
      }
      v4j() {
        var oldTail = ensureNotNull(this.y4h_1);
        var newTail = oldTail.k4i_1;
        this.y4h_1 = newTail;
        if (newTail == null) {
          this.x4h_1 = null;
        } else {
          newTail.j4i_1 = null;
        }
        oldTail.k4i_1 = null;
        SegmentPool_instance.u4j(oldTail);
      }
    }
    protoOf($).i4j = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
